module.exports = __webpack_public_path__ + "static/media/Sidebar-transfers-icon-inactive.fe48ba01.svg";